import api from '../backAxios';
import apiZelo from '../backAxiosVendaToken';
import apiAdyen from '../backAxiosPagamentoToken';

class MensalidadeService {
    async buscaMensalidadesPorInscricao(inscricao) {
        try {
            const mensalidades = await apiZelo.get(
                `/mensalidades/todas/${inscricao}`
            );

            return mensalidades.status === 204 ? [] : mensalidades.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async geraBoleto(bodyBoleto) {
        try {
            const boleto = await apiAdyen.post(
                '/boleto',
                bodyBoleto
            );

            return boleto.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async buscaAssociadoPorInscricao(inscricao) {
        try {
            const associado = await apiZelo.get(
                `/Associados/${inscricao}`
            );

            return associado.data[0];
        } catch (error) {
            throw new Error(error);
        }
    }

    async calculoJuros(parcelas) {
        try {
            const parcelasComJuros = await api.post(
                '/pagamentos/calcular-juros',
                parcelas
            );

            return parcelasComJuros.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async pagamentoParcelasCartao(pagamento) {
        try {
            const pagamentoAdyen = await apiAdyen.post(
                '/cartao',
                pagamento
            );

            return pagamentoAdyen.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async envioPixEmail(bodyPix) {
        try {
            const envioEmail = await apiZelo.post(
                '/pagamentos/envia-qrcode-email',
                bodyPix
            );

            return envioEmail.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async enviaBoletoEmail(bodyEmail) {
        try {
            const enviarBoleto = await api.post(
                '/pagamentos/envia-boleto-email',
                bodyEmail
            );

            return enviarBoleto.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async buscaCarnetGerencianet(inscricao, origem) {
        try {
            const carnet = await apiZelo.get(`pagamentos/carne/${origem}/baixar/${inscricao}/`, { responseType: 'blob' });

            return carnet.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async consultaElegiveis(inscricao) {
        try {
            const carnet = await apiZelo.get(`pagamentos/consulta-elegiveis/${inscricao}`);

            return carnet.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async buscaBonificacaoMensalidades(query) {
        try {
            const endpoint = query ? `/mensalidades/buscar-bonificacao${query}` : '/mensalidades/buscar-bonificacao';
            const bonificacao = await apiZelo.get(endpoint);

            return bonificacao.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async criarBonificacaoMensalidades(body) {
        try {
            const response = await apiZelo.post(
                '/mensalidades/criar-bonificacao',
                body
            );

            return response.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async editarBonificacaoMensalidades(id, body) {
        try {
            const response = await apiZelo.patch(
                `/mensalidades/atualizar-bonificacao/${id}`,
                body
            );

            return response.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async vincularBonificacaoAoProduto(body) {
        try {
            return await apiZelo.post(
                '/mensalidades/vincula-bonificacao-produto',
                body
            );
        } catch (error) {
            if (error.response && error.response.status === 404) {
                return { status: 404 };
            }

            throw new Error(error);
        }
    }

    async excluirBonificacaoMensalidades(id) {
        try {
            await apiZelo.delete(`/mensalidades/excluir-bonificacao/${id}`);
        } catch (error) {
            throw new Error(error);
        }
    }
}

export default new MensalidadeService();
